import keyBy from 'lodash/keyBy';

export default function updateProperties(
    {properties}: UpdateTrackPropertiesAction,
    setTracks: React.Dispatch<React.SetStateAction<{[localId: string]: Track}>>
) {
    const data = Array.isArray(properties) ? properties : [properties];

    setTracks((latestTracks) => {
        const updates = data.map((trackProperties: PartialTrackProperties) => ({
            ...latestTracks[trackProperties.localId],
            properties: {
                ...latestTracks[trackProperties.localId].properties,
                ...trackProperties,
            },
        }));

        return {
            ...latestTracks,
            ...keyBy(updates, (track) => track.properties.localId),
        };
    });

    return data.map((trackProperties) => trackProperties.localId);
}
